import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';

import { MfaSessionScansQuery } from '../MfaSessionScans.generated';

export const transformMfaSessionScansResults = (
	rawResults: MfaSessionScansQuery
): Map<string, string> => {
	const scanCreatedAtMap = new Map<string, string>();

	rawResults.scans?.forEach((scan) => {
		if (scan?.scan_id && scan?.created_at) {
			scanCreatedAtMap.set(scan.scan_id, formatShortMonthDatetime(scan.created_at) ?? '');
		}
	});

	return scanCreatedAtMap;
};
